<template>
	<div class="card-body">
    <div v-if="['admin', 'owner','staff'].includes(this.$store.getters.role)">
      <div v-if="$store.state.brand_settings['whitelabel'] == '0'" class="d-flex align-items-center rounded p-5 mb-9" style="background-color: #e9e9f0">  
        <div class="d-flex flex-column flex-grow-1 mr-2">
          <div class="row">
              <div class="my-10 col-md-10">
                <p  class="text-dark font-weight-bold font-size-sm mb-1" style="color: #ffffff">{{$t('refrel_text_primary')}}</p>
                <span class="text-dark font-size-sm" id="refer_cta">
                  <router-link to="/dashboard/referrals/create">{{$t('click_here')}}</router-link> {{$t('refrel_text_secondary')}} &#128515;
                </span>
              </div> 
              <div class="col-md-2 my-2">
                <span class="align-right float-right">
                  <img src="/images/users/referalIcon.png"  style="width:100px;height: 100px ;margin-top: -5px" alt="image" />
                </span> 
              </div>
            </div>
        </div>
      </div>
    </div>
    <div v-if="['customer-contact'].includes(this.$store.getters.role)">
      <div v-if="$store.state.brand_settings['whitelabel'] == '0'" class="d-flex align-items-center rounded p-5 mb-9" style="background-color: #e9e9f0">  
        <div class="d-flex flex-column flex-grow-1 mr-2">
          <div class="row">
            <div class="my-10 col-md-10">
              <p class="text-dark font-weight-bolder font-size-sm mb-1" style="color: #ffffff">{{ $t('Refrel Title') }}</p>
              <span class="text-dark font-size-sm" >
                <router-link to="/shop/referrals/create">{{$t('click_here')}} </router-link> {{ $t('Refrel Text') }}   &#128515;
              </span>
            </div> 
            <div class="col-md-2 my-2">
              <span class="align-right float-right">
                <img src="/images/users/referalIcon.png"  style="width:100px;height: 100px ;margin-top: -5px" alt="image" />
              </span> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
	export default{
    name:"Referral"
	};
</script>